module.exports = __webpack_public_path__ + "img/F Pregame Field Passes.3bbe5d0d.jpg";